import { Component, OnInit,Input,EventEmitter,Output,ChangeDetectorRef} from '@angular/core';
import { Router } from '@angular/router';
import{SubjectManagmentService} from '../../../Services/subject-management/subject-management.service';
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup } from '@angular/forms';
import { SubjectListResourceAssign } from 'src/app/Models/subject-list-resource-assign';

@Component({
  selector: 'app-subject-list-resource-assignment',
  templateUrl: './subject-list-resource-assignment.component.html',
  styleUrls: ['./subject-list-resource-assignment.component.css']
})
export class SubjectListResourceAssignmentComponent implements OnInit {
  Resourceform: FormGroup;
  SearchListResourceAssign: SubjectListResourceAssign;
  @Input() EditResourcePopup:boolean;
  Breadcrumblist: any;
  @Output() Save: EventEmitter<any> = new EventEmitter<any>();
  

  
  constructor(private cdr: ChangeDetectorRef,public service:SubjectManagmentService,private toastr: ToastrService,private fb: FormBuilder,private route:Router) { }
  InitializeForm(){
    this.Resourceform = this.fb.group({
      LanguageTypeCode:[], 
      SubjectId:[],
      ResourceType:[], 
      PowerUserID:[], 
    });
  }


  ngOnInit() {
    this.getLanguage();
    this.getSubject();
    this.getRoleType();
    this.InitializeForm();
    //this.cdr.detectChanges();

    console.log('ResourceAssignform:', this.ResourceAssignform);
    console.log('EditResourceflag:', this.EditResourceflag);
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  getlanguage:any;
  getLanguage()
  {
    this.service.GetCode({'Tablename':"LANGUAGE_TYPE"}).subscribe((i:any)=>{
      this.getlanguage=i;
    // }).catch((e:any)=>{
    //   this.getlanguage=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }

  getsubjectlist:any;
  getSubject()
  {
    this.service.GetCodeSubject({'Tablename':"SUBJECT"}).subscribe((i:any)=>{
      this.getsubjectlist=i;
    }, (error:any) => { console.log(error) }
    );
  }

  getroletype:any;
  getRoleType()
  {
    this.service.GetCode({'Tablename':"POWER_USER_ROLE_TYPE"}).subscribe((i:any)=>{
      this.getroletype=i;
    }, (error:any) => { console.log(error) }
    );
  }

  checked:boolean;
  checkboxvalue:string="N";
  checkbox(){
    this.checked=!this.checked;
    if(this.checked)
    this.checkboxvalue="Y";
    else
    this.checkboxvalue="N";
  }
 
  ResourceName:any
  getresourcedetails:any
  ngselect:any;
  selectrolecode:any
  getResourceName(index:number)
  {
    for (let item of this.getroletype) {
      if (item.Code==index) {
         this.selectrolecode==item;
      }
  }
    this.ResourceName = {
      
      LanguageTypeCode:"MAL",
      SubjectID:1,
      PowerUserRoleTypeCode:"SA",
      PowerUserRoleStatusTypeCode:null,
      ExcludedPowerUserID:null,
      translatedInd:null
      
    }
    this.service.GetPowerUserByRole(this.ResourceName).subscribe((i:any)=>{
      this.getresourcedetails=i;
      this.ngselect=this.getresourcedetails.Full_Name;
    // }).catch((e:any)=>{
    //   this.getresourcedetails=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }

  
  RedirectAssignedresourceId:Number;
   RedirecttoAssignedresource(id:Number,data:Number)
  {
    this.RedirectAssignedresourceId=id;
    this.EditResourcePopup=!this.EditResourcePopup; 
    this.getBreadcrumbDetails(data); 
  }

  RedirectRemoveResourceId:Number
  RemoveResourcePopup:boolean
  RemoveResource(id:Number,data:Number){
    this.RedirectRemoveResourceId=id;
    this.RemoveResourcePopup=!this.RemoveResourcePopup; 
    this.EditResourcePopup=!this.EditResourcePopup;
    this.getBreadcrumbDetails(data); 
  }
  cancelEditPopup(){
    this.EditResourcePopup=!this.EditResourcePopup; 
    if(this.EditResouceclosepopupflag){
      this.EditResouceClosepopup();
    }
    
  }
  cancelpopup(data:any){
   
    this.RemoveResouceClosepopup();
    
  }

  cancelRemoveResourcePopup(data:any){
    this.RemoveResourcePopup=!this.RemoveResourcePopup; 
    this.ResourceAssignSearch();
    if(this.RemoveResouceclosepopupflag){
    this.RemoveResouceClosepopup();
    }
  }

  reset(data:boolean){
    this.cancelEditPopup();
  }
  popup(data:boolean){
    if(this.EditResouceclosepopupflag){
    this.EditResouceClosepopup();
    }
  }
  refresh(data:boolean){
    this.ResourceAssignSearch();
  }
  listResourceCancel(){
   this.InitializeForm();
  }
  EditResourceflag:boolean=false;
  ResourceAssignform:FormGroup;
  DisableButton(data:any){
    this.EditResourceflag=data.EditResourceflag;
    this.ResourceAssignform=data.ResourceAssignform.valid;
  }


    check:boolean;
    RemoveResourceAssignform:FormGroup;
  DisableButton1(data:any){
    this.check=data.check;
    this.RemoveResourceAssignform=data.RemoveResourceAssignform.valid;
  }

  Searchlistresponse:any;
  Search:any;
  ResourceAssignSearch()
  {
      this.SearchListResourceAssign=this.Resourceform.value;
      this.SearchListResourceAssign.ActiveAssignmentOnly=this.checkboxvalue;
      this.service.SearchSubjectRoleAssignment(this.SearchListResourceAssign).subscribe((i:any)=>{
        this.Search=i;
        this.Searchlistresponse=this.Search.SubjectExistsInd;
  //  }).catch((e:any)=>{
  //    this.Searchlistresponse=e;
  //    this.toastr.error(this.Searchlistresponse.statusText)
  //  }
  //  ) 
}, (error:any) => { console.log(error) }
);
  }

  getBreadcrumbDetails(data: any) {
    this.service.getBreadcrumbDetails({ 'ID': data }).subscribe((i: any) => {
      this.Breadcrumblist = i;
    // }).catch((e: any) => {
    //   this.Breadcrumblist = null;
    // }
    // )
  }, (error:any) => { console.log(error) }
  );
    
  }

  
  EditResouceclosepopupflag:boolean=false;
  EditResouceClosepopup(){
    this.EditResouceclosepopupflag=!this.EditResouceclosepopupflag;
  }

  RemoveResouceclosepopupflag:boolean;
  RemoveResouceClosepopup(){
    this.RemoveResouceclosepopupflag=!this.RemoveResouceclosepopupflag;
  }
  
  Saveflag:boolean;
  save(){
    this.Save.emit(this.Saveflag);
  }
  getresourcevalue(data:any){
    this.getResourceName(data.target.value)
  }

}
